import * as adminRelease from './adminRelease';
import * as login from './login';
import * as publicSettings from './public';
import * as systemSettings from './systemSettings';
import * as Forum from './forum';
import * as Specialist from './specialist';
import * as Me from './me'
import * as Home from './home';
import * as AdminForum from './adminForum'
import * as Log from './log'
import * as AdminPurchase from './adminPurchase';
import * as NewTech from './newTech';
export default {
  ...login,
  ...adminRelease,
  ...publicSettings,
  ...systemSettings,
  ...Forum,
  ...Specialist,
  ...Me,
  ...Home,
  ...AdminForum,
  ...Log,
  ...AdminPurchase,
  ...NewTech
}


// WEBPACK FOOTER //
// ./src/request/index.js